<template>
    <div id="v-index-wrap">
        <!-- 顶部栏 -->
        <div class="head">
            <dl>
                <dt>
                    <img class="logo" :src="$config.resource + 'dhl_logo.png'" alt="">
                </dt>
                <!-- 头像信息 -->
                <dd>
                    <div class="portrait">
                        <img class="pic" :src="user.head" alt="">
                    </div>
                    <p>{{user.company_name}}</p>
                    <div class="quit" @click="onQuit">
                        <img class="icon" :src="$config.resource + 'tc.png'" alt="">
                    </div>
                </dd>
            </dl>
        </div>
        <!-- 主要部分 -->
        <div class="main_box">
            <!-- 背景图 -->
            <img class="pic_bg" :src="$config.resource + 'jd_bj.png'" alt="">
            <!-- 流程 -->
            <div class="flow">
                <div class="wire"></div>
                <!-- 第一阶段 -->
                <div class="describe">
                    <!-- 当前步骤显示 -->
                    <div class="Baymax" v-if="flow.write1!=1">
                        <div class="tt">第一阶段信息填写</div>
                        <div class="circle"></div>
                        <div class="row">
                            <img class="db_bg" :src="$config.resource + 'jdsh.png'">
                            <div class="bag">
                                <img class="icon" :src="$config.resource + 'nrtx.png'">
                                <p><em>内容填写</em></p>
                                <p><samp>请根据公司情况填写内容</samp></p>
                            </div>
                        </div>
                    </div>
                    <!-- 已通过当前步骤显示 -->
                    <div class="via" v-if="flow.write1==1">
                        <div class="tt">第一阶段信息填写</div>
                        <div class="circle"></div>
                        <div class="row">
                            <img class="db_bg" :src="$config.resource + 'jdb.png'">
                            <div class="name">填写完成</div>
                        </div>
                    </div>
                </div>
                <div class="wire"></div>
                <!-- 初审 -->
                <div class="describe">
                    <!-- 当前步骤显示 -->
                    <div class="Baymax" v-if="flow.write1==1&&flow.status1!=2">
                        <div class="tt">初审</div>
                        <div class="circle"></div>
                        <div class="row">
                            <img class="db_bg" :src="$config.resource + 'jdsh.png'">
                            <!-- 失败 -->
                            <div class="bag" v-if="flow.status1==1">
                                <img class="icon" :src="$config.resource + 'shsb.png'">
                                <p><em>审核失败</em></p>
                                <p><samp>请重新填写第一阶段内容</samp></p>
                            </div>
                            <!-- 审核中 -->
                            <div class="bag" v-if="flow.status1==3">
                                <img class="icon" :src="$config.resource + 'shz.png'">
                                <p><em>审核中</em></p>
                                <p><samp>请留意手机短信的结果</samp></p>
                            </div>
                        </div>
                    </div>
                    <!-- 未到当前步骤显示 -->
                    <div class="clear" v-if="flow.write1!=1">
                        <div class="tt">初审</div>
                        <div class="circle"></div>
                        <div class="row">
                            <img class="db_bg" :src="$config.resource + 'jdtm.png'">
                            <div class="bag">
                                <p><em>初次审核</em></p>
                                <p><samp>请留意手机短信的结果</samp></p>
                            </div>
                        </div>
                    </div>
                    <!-- 已通过当前步骤显示 -->
                    <div class="via" v-if="flow.write1&&flow.status1==2">
                        <div class="tt">初审</div>
                        <div class="circle"></div>
                        <div class="row">
                            <img class="db_bg" :src="$config.resource + 'jdb.png'">
                            <div class="name">审核成功</div>
                        </div>
                    </div>
                </div>
                <div class="wire"></div>
                <!-- 第二阶段 -->
                <div class="describe">
                    <!-- 当前步骤显示 -->
                    <div class="Baymax" v-if="flow.write2!=1&&flow.status1==2">
                        <div class="tt">第二阶段信息填写</div>
                        <div class="circle"></div>
                        <div class="row">
                            <img class="db_bg" :src="$config.resource + 'jdsh.png'">
                            <div class="bag">
                                <img class="icon" :src="$config.resource + 'nrtx.png'">
                                <p><em>内容填写</em></p>
                                <p><samp>请根据公司情况填写内容</samp></p>
                            </div>
                        </div>
                    </div>
                    <!-- 未到当前步骤显示 -->
                    <div class="clear" v-if="flow.write2!=1&&flow.status1!=2">
                        <div class="tt">第二阶段信息填写</div>
                        <div class="circle"></div>
                        <div class="row">
                            <img class="db_bg" :src="$config.resource + 'jdtm.png'">
                            <div class="bag">
                                <p><em>内容填写</em></p>
                                <p><samp>请根据公司情况填写内容</samp></p>
                            </div>
                        </div>
                    </div>
                    <!-- 已通过当前步骤显示 -->
                    <div class="via" v-if="flow.write2==1">
                        <div class="tt">第二阶段信息填写</div>
                        <div class="circle"></div>
                        <div class="row">
                            <img class="db_bg" :src="$config.resource + 'jdb.png'">
                            <div class="name">填写完成</div>
                        </div>
                    </div>
                </div>
                <div class="wire"></div>
                <!-- 终审 -->
                <div class="describe">
                    <!-- 当前步骤显示 -->
                    <div class="Baymax" v-if="flow.write2==1">
                        <div class="tt">终审</div>
                        <div class="circle"></div>
                        <div class="row">
                            <img class="db_bg" :src="$config.resource + 'jdsh.png'">
                            <!-- 失败 -->
                            <div class="bag"  v-if="flow.status2==1">
                                <img class="icon" :src="$config.resource + 'shsb.png'">
                                <p><em>审核失败</em></p>
                                <p><samp>请重新填写第二阶段内容</samp></p>
                            </div>
                            <!-- 审核中 -->
                            <div class="bag" v-if="flow.status2==3">
                                <img class="icon" :src="$config.resource + 'shz.png'">
                                <p><em>审核中</em></p>
                                <p><samp>请留意手机短信的结果</samp></p>
                            </div>
                            <!-- 审核成功 -->
                            <div class="bag" v-if="flow.status2==2">
                                <img class="icon" :src="$config.resource + 'shcg.png'">
                                <p><em>审核成功</em></p>
                            </div>
                        </div>
                    </div>
                    <!-- 未到当前步骤显示 -->
                    <div class="clear" v-if="flow.write2!=1">
                        <div class="tt">终审</div>
                        <div class="circle"></div>
                        <div class="row">
                            <img class="db_bg" :src="$config.resource + 'jdtm.png'">
                            <div class="bag">
                                <p><em>最终审核</em></p>
                                <p><samp>请留意手机短信的结果</samp></p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="wire"></div>
            </div>
            <!-- 按钮 -->
            <!-- 流程一按钮 -->
            <div class="btn_box" v-if="flow.write1!=1">
                <div class="btn gray" @click="onDown">填写操作指导书下载</div>
                <div class="btn gray btn_two" @click="onPreview">填写操作指导书预览</div>
                <div class="btn red" @click="toViewPage('/supplier',{type:1})">立即填写</div>
            </div>
            <!-- 流程二按钮 -->
            <div class="btn_box" v-if="flow.write1==1&&flow.status1!=2">
                <!-- 审核中 -->
                <div class="btn gray" @click="onAwait" v-if="flow.status1==3">等待结果</div>
                <!-- 失败 -->
                <div class="btn red" @click="toViewPage('/supplier',{type:3})" v-if="flow.status1==1">重新填写</div>
            </div>
            <!-- 流程三按钮 -->
            <div class="btn_box" v-if="flow.write2!=1&&flow.status1==2">
                <div class="btn red" @click="toViewPage('/knowledge',{type:1})">立即填写</div>
            </div>
            <!-- 流程四按钮 -->
            <div class="btn_box" v-if="flow.write2==1&&flow.status1==2">
                <!-- 审核中 -->
                <div class="btn gray" v-if="flow.status2==3" @click="onAwait">等待结果</div>
                <!-- 失败 -->
                <div class="btn red" v-if="flow.status2==1" @click="toViewPage('/knowledge',{type:3})">重新填写</div>
                <!-- 成功 -->
                <div class="btn red" v-if="flow.status2==2" @click="toViewPage('/supplier',{type:2})">查看填写信息</div>
            </div>

            <el-image-viewer
                v-if="isPicture"
                :on-close="closeViewer"
                :url-list="picture"
            />
        </div>
    </div>
</template>
<script>
    import store from '../vuex/store.js';
    import ElImageViewer from 'element-ui/packages/image/src/image-viewer'
    export default {
        data(){
            return{
                user:'',// 用户信息
                flow:'',// 流程状态
                picture:'',// 大图
                isPicture:false,// 预览大图
            }
        },
        store,
        methods: {
            //页面跳转
            toViewPage($path,$query,$lang) {
                this.$jump.toViewPage(this,$path,$query)
            },
            // 用户信息
            getUser(){
                const that = this
                that.$request({
                    that: that,
                    api: that.$api.consumer,
                    data: {},
                    success(res) {
                       that.user = res.data
                       that.homeState()
                       that.getPreview()
                    }
                })
            },
            // 获取流程状态
            homeState(){
                const that = this
                that.$request({
                    that: that,
                    api: that.$api.flowState,
                    data: {},
                    success(res) {
                       that.flow = res.data
                    }
                })
            },
            // 退出
            onQuit(){
                const that = this
                //存储用户登录凭证
                that.$storage.remove('accesstoken')

                //登录成功发起页面跳转
                that.$dialog.toast({
                    mes: '退出登录成功',
                    timeout: 2000,
                    icon: 'success',
                    callback(){
                        that.$router.push({ path: '/logIn' })
                    }
                })
            },
            // 下载指导书
            onDown(){
                const that = this
                that.$request({
                    that: that,
                    api: that.$api.downInstructor,
                    data: {},
                    success(res) {
                       window.open(res.data.src)
                    }
                })
            },
            // 查看指导书
            onPreview(){
                this.isPicture = true
            },
            // 关闭图片预览
            closeViewer() {
                this.isPicture = false
            },
            // 预览指导书
            getPreview(){
                const that = this
                that.$request({
                    that: that,
                    api: that.$api.pvwInstructor,
                    data: {},
                    success(res) {
                       that.picture = res.data.src
                    }
                })
            },
            // 等待结果
            onAwait(){
                this.$dialog.toast({
                    mes:'正在审核中，请耐心等待结果',
                    timeout: 1500,
                    icon: 'none',
                })
            },
        },
        mounted() {
            const that = this
            that.$store.commit('EditPageData',this.PageData)
            that.getUser()// 用户信息
        },
        components:{
            ElImageViewer 
        },
    }
</script>


// WEBPACK FOOTER //
// src/page/Index.vue